function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_10655_92943)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.1998 22H18.8C19.3523 22 19.8 21.5523 19.8 21V1C19.8 0.447715 19.3523 0 18.8 0H1C0.447715 0 0 0.447716 0 1V21C0 21.5523 0.447716 22 1 22H5.60022H9.9H14.1998ZM16 20H17C17.5523 20 18 19.5523 18 19V11V6.5V3C18 2.44772 17.5523 2 17 2H15H3C2.44772 2 2 2.44772 2 3V11V19C2 19.5523 2.44772 20 3 20H6H9.9H16Z",
  fill: "#18CDA6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 5H16V7H4V5Z",
  fill: "#18CDA6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 9H7.59998H10.6V11.0008H4V9Z",
  fill: "#18CDA6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 13H13.9V15H9H4V13Z",
  fill: "#18CDA6"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_10655_92943"
}, /*#__PURE__*/React.createElement("rect", {
  width: 19.8,
  height: 22,
  fill: "white"
})));

var SvgDetails = function SvgDetails(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDetails, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/details.6505b1c4.svg";
export { ForwardRef as ReactComponent };